// Website site chrome — the header and footer every page shares (Blog design export,
// owner's call 4 Nov 2026). Spread into en.ts / bn.ts. Labels the old header already had
// (nav.offers, nav.sign_in, footer.terms …) are reused; these are the design's new lines:
// mega-menu sub-lines and feature cards, the newsletter band and the switches.
// Tenant-blind (INF-1): the brand and market are {brand} / {region} placeholders.
export const siteChromeEn = {
  'sc.cat_sub.hotel': 'Rooms, day-outs, packages',
  'sc.cat_sub.restaurant': 'Buffets, reserved tables',
  'sc.cat_sub.turf': 'Turfs, courts, pools',
  'sc.cat_sub.generic': 'Browse and book',
  'sc.offers.live_sub': 'Deals valid right now',
  'sc.offers.trending_sub': 'Most-claimed this week',
  'sc.offers.reels_sub': 'Short videos of deals',
  'sc.offers.card_eyebrow': 'Today',
  'sc.offers.card_title': 'New offers every day',
  'sc.offers.card_body': 'Hotels, turfs & buffets — updated daily. Yesterday’s deal may be gone.',
  'sc.offers.card_go': 'See today’s offers',
  'sc.book.trending_sub': 'Most booked this week',
  'sc.book.near_sub': 'Around your location',
  'sc.book.top_sub': '4.5+ with verified reviews',
  'sc.book.new_sub': 'Freshly listed and inspected',
  'sc.book.card_eyebrow': 'Verified',
  'sc.book.card_title': 'Team-inspected listings',
  'sc.book.card_body': 'Every place is reviewed before it goes live. Look for the badge.',
  'sc.book.card_go': 'How trust works',
  'sc.res.business_sub': 'List free, post offers',
  'sc.res.blog_sub': 'Guides and stories',
  'sc.res.help_sub': 'Answers and support',
  'sc.account': 'My account',
  'sc.language': 'Language',
  'sc.lang_to_bn': 'Switch to Bangla',
  'sc.lang_to_en': 'Switch to English',
  'sc.dark_mode': 'Dark mode',
  'sc.nl.title': 'One email a week. New offers, new guides.',
  'sc.nl.body':
    'Offers on {brand} change every day. Get the best of the week plus one practical guide for guests or business owners.',
  'sc.nl.email_label': 'Email address',
  'sc.nl.placeholder': 'you@example.com',
  'sc.nl.submit': 'Subscribe',
  'sc.nl.sending': 'Subscribing…',
  'sc.nl.ok': 'Thanks! You’re on the list — one email a week.',
  'sc.nl.invalid': 'Enter a valid email address.',
  'sc.nl.failed': 'We could not subscribe you right now. Please try again.',
  'sc.social.linkedin': 'LinkedIn',
  'sc.social.tiktok': 'TikTok',
  'sc.social.x': 'X',
  'dc56.post.quick_answer': 'Quick answer',
  'dc56.post.faq': 'Frequently asked questions',
} as const satisfies Record<string, string>;

export const siteChromeBn = {
  'sc.cat_sub.hotel': 'রুম, ডে-আউট, প্যাকেজ',
  'sc.cat_sub.restaurant': 'বুফে, রিজার্ভড টেবিল',
  'sc.cat_sub.turf': 'টার্ফ, কোর্ট, পুল',
  'sc.cat_sub.generic': 'দেখুন ও বুক করুন',
  'sc.offers.live_sub': 'এখনই বৈধ ডিল',
  'sc.offers.trending_sub': 'এ সপ্তাহে সবচেয়ে বেশি নেওয়া',
  'sc.offers.reels_sub': 'ডিলের ছোট ভিডিও',
  'sc.offers.card_eyebrow': 'আজ',
  'sc.offers.card_title': 'প্রতিদিন নতুন অফার',
  'sc.offers.card_body': 'হোটেল, টার্ফ ও বুফে — প্রতিদিন আপডেট। গতকালের ডিল আজ নাও থাকতে পারে।',
  'sc.offers.card_go': 'আজকের অফার দেখুন',
  'sc.book.trending_sub': 'এ সপ্তাহে সবচেয়ে বেশি বুক',
  'sc.book.near_sub': 'আপনার লোকেশনের আশপাশে',
  'sc.book.top_sub': 'ভেরিফায়েড রিভিউসহ ৪.৫+',
  'sc.book.new_sub': 'নতুন লিস্টেড ও পরিদর্শিত',
  'sc.book.card_eyebrow': 'ভেরিফায়েড',
  'sc.book.card_title': 'টিম-পরিদর্শিত লিস্টিং',
  'sc.book.card_body': 'প্রতিটি জায়গা লাইভ হওয়ার আগে যাচাই হয়। ব্যাজ দেখে নিন।',
  'sc.book.card_go': 'বিশ্বাস কীভাবে কাজ করে',
  'sc.res.business_sub': 'বিনামূল্যে লিস্ট, অফার পোস্ট',
  'sc.res.blog_sub': 'গাইড ও গল্প',
  'sc.res.help_sub': 'উত্তর ও সাপোর্ট',
  'sc.account': 'আমার অ্যাকাউন্ট',
  'sc.language': 'ভাষা',
  'sc.lang_to_bn': 'বাংলায় দেখুন',
  'sc.lang_to_en': 'ইংরেজিতে দেখুন',
  'sc.dark_mode': 'ডার্ক মোড',
  'sc.nl.title': 'সপ্তাহে একটি ইমেইল। নতুন অফার, নতুন গাইড।',
  'sc.nl.body': '{brand}-তে অফার প্রতিদিন বদলায়। সপ্তাহের সেরা অফার আর একটি কাজের গাইড পান।',
  'sc.nl.email_label': 'ইমেইল ঠিকানা',
  'sc.nl.placeholder': 'you@example.com',
  'sc.nl.submit': 'সাবস্ক্রাইব',
  'sc.nl.sending': 'সাবস্ক্রাইব হচ্ছে…',
  'sc.nl.ok': 'ধন্যবাদ! আপনি তালিকায় আছেন — সপ্তাহে একটি ইমেইল পাবেন।',
  'sc.nl.invalid': 'সঠিক ইমেইল ঠিকানা লিখুন।',
  'sc.nl.failed': 'এখন সাবস্ক্রাইব করা যায়নি। আবার চেষ্টা করুন।',
  'sc.social.linkedin': 'লিংকডইন',
  'sc.social.tiktok': 'টিকটক',
  'sc.social.x': 'এক্স',
  'dc56.post.quick_answer': 'সংক্ষিপ্ত উত্তর',
  'dc56.post.faq': 'প্রায়ই জিজ্ঞাসিত প্রশ্ন',
} as const satisfies Record<keyof typeof siteChromeEn, string>;
